import React from "react";

// reactstrap components
import { Container } from "reactstrap";

function Header(props) {
  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 ">
        <Container fluid>
          
        </Container>
      </div>
    </>
  );
}



export default Header;
